import {SchemaDefinition} from '~/backend/src/connectors/db/dbDefinition/DbDefinitionMapperUtilities';

const schemaDefinition : SchemaDefinition = {
    tables: {
        user                       : {
            table          : 'AUTH_USER',
            hasView        : false,
            fieldMap       : {
                id                : 'AU_ID',
                statusId          : 'AU_AST_ID',
                userId            : 'AU_USERID',
                token             : 'AU_TOKEN',
                surname           : 'AU_SURNAME',
                name              : 'AU_NAME',
                department        : 'AU_DEPARTMENT',
                description       : 'AU_DESCRIPTION',
                isTechnicalUser   : 'AU_IS_TECHNICAL_USER',
                isDataBlockingUser: 'AU_IS_DATA_BLOCKING_USER',
                modifierUserId    : 'AU_MODIFIER',
                modificationTime  : 'AU_MODIFICATION_TIME'
            },
            historyFieldMap: {
                id                : 'AU_ID',
                statusId          : 'AU_AST_ID',
                userId            : 'AU_USERID',
                token             : 'AU_TOKEN',
                surname           : 'AU_SURNAME',
                name              : 'AU_NAME',
                department        : 'AU_DEPARTMENT',
                description       : 'AU_DESCRIPTION',
                isTechnicalUser   : 'AU_IS_TECHNICAL_USER',
                isDataBlockingUser: 'AU_IS_DATA_BLOCKING_USER',
                modifierUserId    : 'AU_MODIFIER',
                validFromTime     : 'AU_VALID_FROM',
                validToTiome      : 'AU_VALID_TO'
            },
            fieldTypesMap  : {
                id                : 'INTEGER',
                statusId          : 'INTEGER',
                userId            : 'STRING',
                token             : 'STRING',
                surname           : 'STRING',
                name              : 'STRING',
                department        : 'STRING',
                description       : 'TEXT',
                isTechnicalUser   : 'BOOLEAN',
                isDataBlockingUser: 'BOOLEAN',
                modifierUserId    : 'STRING',
                modificationTime  : 'TIMESTAMP',
                validatorUserId   : 'STRING',
                validationTime    : 'TIMESTAMP',
                validFromTime     : 'TIMESTAMP',
                validToTime       : 'TIMESTAMP'
            }
        },
        userToken                  : {
            table          : 'AUTH_USER_TOKEN',
            hasView        : false,
            hasHistoryTable: false,
            fieldMap       : {
                id              : 'AUT_ID',
                userId          : 'AUT_AU_ID',
                name            : 'AUT_NAME',
                key             : 'AUT_KEY',
                hash            : 'AUT_HASH',
                modifierUserId  : 'AUT_MODIFIER',
                modificationTime: 'AUT_MODIFICATION_TIME'
            },
            fieldTypesMap  : {
                id              : 'INTEGER',
                userId          : 'INTEGER',
                name            : 'STRING',
                key             : 'STRING',
                hash            : 'STRING',
                modifierUserId  : 'STRING',
                modificationTime: 'TIMESTAMP'
            }
        },
        userGroup                  : {
            table          : 'AUTH_USER_GROUP',
            hasView        : false,
            fieldMap       : {
                id              : 'AUG_ID',
                statusId        : 'AUG_AST_ID',
                userId          : 'AUG_AU_ID',
                groupId         : 'AUG_AG_ID',
                changeReason    : 'AUG_CHANGE_REASON',
                modifierUserId  : 'AUG_MODIFIER',
                modificationTime: 'AUG_MODIFICATION_TIME'
            },
            historyFieldMap: {
                id            : 'AUG_ID',
                statusId      : 'AUG_AST_ID',
                userId        : 'AUG_AU_ID',
                groupId       : 'AUG_AG_ID',
                changeReason  : 'AUG_CHANGE_REASON',
                modifierUserId: 'AUG_MODIFIER',
                validFromTime : 'AUG_VALID_FROM',
                validToTime   : 'AUG_VALID_TO'
            },
            fieldTypesMap  : {
                id              : 'INTEGER',
                statusId        : 'INTEGER',
                userId          : 'INTEGER',
                groupId         : 'INTEGER',
                changeReason    : 'STRING',
                modifierUserId  : 'STRING',
                modificationTime: 'TIMESTAMP',
                validFromTime   : 'TIMESTAMP',
                validToTime     : 'TIMESTAMP'
            }
        },
        group                      : {
            table          : 'AUTH_GROUP',
            hasView        : false,
            fieldMap       : {
                id              : 'AG_ID',
                statusId        : 'AG_AST_ID',
                name            : 'AG_NAME',
                comment         : 'AG_COMMENT',
                modifierUserId  : 'AG_MODIFIER',
                modificationTime: 'AG_MODIFICATION_TIME'
            },
            historyFieldMap: {
                id            : 'AG_ID',
                statusId      : 'AG_AST_ID',
                name          : 'AG_NAME',
                comment       : 'AG_COMMENT',
                modifierUserId: 'AG_MODIFIER',
                validFromTime : 'AG_VALID_FROM',
                validToTime   : 'AG_VALID_TO'
            },
            fieldTypesMap  : {
                id              : 'INTEGER',
                statusId        : 'INTEGER',
                name            : 'STRING',
                comment         : 'STRING',
                modifierUserId  : 'STRING',
                modificationTime: 'TIMESTAMP',
                validFromTime   : 'TIMESTAMP',
                validToTime     : 'TIMESTAMP'
            }
        },
        status                     : {
            table          : 'AUTH_STATUS',
            hasView        : false,
            fieldMap       : {
                id              : 'AST_ID',
                name            : 'AST_NAME',
                description     : 'AST_DESCRIPTION',
                color           : 'AST_COLOR',
                modifierUserId  : 'AST_MODIFIER',
                modificationTime: 'AST_MODIFICATION_TIME',
                uuid            : 'AST_UUID'
            },
            historyFieldMap: {
                id            : 'AST_ID',
                name          : 'AST_NAME',
                description   : 'AST_DESCRIPTION',
                color         : 'AST_COLOR',
                modifierUserId: 'AST_MODIFIER',
                validFromTime : 'AST_VALID_FROM',
                validToTiome  : 'AST_VALID_TO'
            },
            fieldTypesMap  : {
                id              : 'INTEGER',
                name            : 'STRING',
                description     : 'TEXT',
                color           : 'STRING',
                modifierUserId  : 'STRING',
                modificationTime: 'TIMESTAMP',
                validFromTime   : 'TIMESTAMP',
                validToTime     : 'TIMESTAMP'
            }
        },
        object                     : {
            table          : 'AUTH_OBJECT',
            hasView        : false,
            fieldMap       : {},
            historyFieldMap: {}
        },
        objectPermission           : {
            table        : 'AUTH_OBJECT_PERMISSION',
            hasView      : false,
            fieldMap     : {
                id              : 'AOP_ID',
                statusId        : 'AOP_AST_ID',
                groupId         : 'AOP_AG_ID',
                objectId        : 'AOP_AO_ID',
                permission      : 'AOP_PERMISSION',
                modifierUserId  : 'AOP_MODIFIER',
                modificationTime: 'AOP_MODIFICATION_TIME'
            },
            fieldTypesMap: {
                id              : 'INTEGER',
                statusId        : 'INTEGER',
                groupId         : 'INTEGER',
                objectId        : 'INTEGER',
                permission      : 'INTEGER',
                modifierUserId  : 'STRING',
                modificationTime: 'TIMESTAMP'
            }
        },
        itemPermission             : {
            table          : 'AUTH_ITEM_PERMISSION',
            hasView        : false,
            fieldMap       : {
                id                              : 'AIP_ID',
                statusId                        : 'AIP_AST_ID',
                groupId                         : 'AIP_AG_ID',
                schema                          : 'AIP_SCHEMA',
                itemTypeId                      : 'AIP_CIT_ID',
                permission                      : 'AIP_PERMISSION',
                genericPermission               : 'AIP_PERMISSION_GENERIC',
                inheritPermissionToPropertySets : 'AIP_INHERIT_PERMISSION_TO_PROPERTIES',
                inheritPermissionToReferenceSets: 'AIP_INHERIT_PERMISSION_TO_REFERENCES',
                modifierUserId                  : 'AIP_MODIFIER',
                modificationTime                : 'AIP_MODIFICATION_TIME'
            },
            historyFieldMap: {}
        },
        propertyPermission         : {
            table          : 'AUTH_PROPERTY_PERMISSION',
            hasView        : false,
            fieldMap       : {
                id               : 'APP_ID',
                statusId         : 'APP_AST_ID',
                groupId          : 'APP_AG_ID',
                schema           : 'APP_SCHEMA',
                propertySetId    : 'APP_CIPS_ID',
                permission       : 'APP_PERMISSION',
                genericPermission: 'APP_PERMISSION_GENERIC',
                modifierUserId   : 'APP_MODIFIER',
                modificationTime : 'APP_MODIFICATION_TIME'
            },
            historyFieldMap: {}
        },
        referencePermission        : {
            table          : 'AUTH_REFERENCE_PERMISSION',
            hasView        : false,
            fieldMap       : {
                id                             : 'ARP_ID',
                statusId                       : 'ARP_AST_ID',
                groupId                        : 'ARP_AG_ID',
                schema                         : 'ARP_SCHEMA',
                referenceSetId                 : 'ARP_CIRS_ID',
                permission                     : 'ARP_PERMISSION',
                genericPermission              : 'ARP_PERMISSION_GENERIC',
                inheritPermissionToPropertySets: 'ARP_INHERIT_PERMISSION_TO_RPROPERTIES',
                modifierUserId                 : 'ARP_MODIFIER',
                modificationTime               : 'ARP_MODIFICATION_TIME'
            },
            historyFieldMap: {}
        },
        referencePropertyPermission: {
            table          : 'AUTH_RPROPERTY_PERMISSION',
            hasView        : false,
            fieldMap       : {
                id                    : 'ARPP_ID',
                statusId              : 'ARPP_AST_ID',
                groupId               : 'ARPP_AG_ID',
                schema                : 'ARPP_SCHEMA',
                referencePropertySetId: 'ARPP_CIRPS_ID',
                permission            : 'ARPP_PERMISSION',
                genericPermission     : 'ARPP_PERMISSION_GENERIC',
                modifierUserId        : 'ARPP_MODIFIER',
                modificationTime      : 'ARPP_MODIFICATION_TIME'
            },
            historyFieldMap: {}
        },
        // session information
        sessionItemPermission             : {
            table          : 'SESSION_ITEM_PERMISSION',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {
                userId           : 'SIP_AU_ID',
                schema           : 'SIP_SCHEMA',
                itemTypeId       : 'SIP_CIT_ID',
                permission       : 'SIP_PERMISSION',
                genericPermission: 'SIP_PERMISSION_GENERIC',
                creationTime     : 'SIP_CREATED'
            },
            fieldTypesMap  : {
                userId           : 'INTEGER',
                schema           : 'STRING',
                itemTypeId       : 'INTEGER',
                permission       : 'INTEGER',
                genericPermission: 'INTEGER',
                creationTime     : 'TIMESTAMP'
            }
        },
        sessionPropertyPermission         : {
            table          : 'SESSION_PROPERTY_PERMISSION',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {
                userId           : 'SPP_AU_ID',
                schema           : 'SPP_SCHEMA',
                propertySetId    : 'SPP_CIPS_ID',
                permission       : 'SPP_PERMISSION',
                genericPermission: 'SPP_PERMISSION_GENERIC',
                creationTime     : 'SPP_CREATED'
            },
            fieldTypesMap  : {
                userId           : 'INTEGER',
                schema           : 'STRING',
                propertySetId    : 'INTEGER',
                permission       : 'INTEGER',
                genericPermission: 'INTEGER',
                creationTime     : 'TIMESTAMP'
            }
        },
        sessionReferencePermission        : {
            table          : 'SESSION_REFERENCE_PERMISSION',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {
                userId           : 'SRP_AU_ID',
                schema           : 'SRP_SCHEMA',
                referenceSetId   : 'SRP_CIRS_ID',
                permission       : 'SRP_PERMISSION',
                genericPermission: 'SRP_PERMISSION_GENERIC',
                creationTime     : 'SRP_CREATED'
            },
            fieldTypesMap  : {
                userId           : 'INTEGER',
                schema           : 'STRING',
                referenceSetId   : 'INTEGER',
                permission       : 'INTEGER',
                genericPermission: 'INTEGER',
                creationTime     : 'TIMESTAMP'
            }
        },
        sessionReferencePropertyPermission: {
            table          : 'SESSION_RPROPERTY_PERMISSION',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {
                userId                : 'SRPP_AU_ID',
                schema                : 'SRPP_SCHEMA',
                referencePropertySetId: 'SRPP_CIRPS_ID',
                permission            : 'SRPP_PERMISSION',
                genericPermission     : 'SRPP_PERMISSION_GENERIC',
                creationTime          : 'SRPP_CREATED'
            },
            fieldTypesMap  : {
                userId                : 'INTEGER',
                schema                : 'STRING',
                referencePropertySetId: 'INTEGER',
                permission            : 'INTEGER',
                genericPermission     : 'INTEGER',
                creationTime          : 'TIMESTAMP'
            }
        },
        // only cockpit
        xmlSender: {
            table          : 'XML_SENDER',
            hasActiveView  : false,
            hasHistoryTable: false,
            hasHistoryView : false,
            hasView        : false,
            fieldMap       : {
                hash       : 'XS_HASH',
                name       : 'XS_NAME',
                sender     : 'XS_SENDER',
                responsible: 'XS_RESPONSIBLE',
                expire     : 'XS_EXPIRE'
            },
            fieldTypesMap  : {
                hash       : 'STRING',
                name       : 'STRING',
                sender     : 'STRING',
                responsible: 'STRING',
                expire     : 'INTEGER'
            }
        }
    }
};

export default schemaDefinition;
